<template>
  <div>
    <CreateProfile
      v-if="activeStep === 1"
      @nextStep="$emit('nextStep', $event)"
      @prevStep="$emit('prevStep', $event)"
    />
    <Notification
      v-show="activeStep === 2"
      :notificationData="notificationData"
      @nextStep="$emit('nextStep', $event)"
      @prevStep="handlePrevStep"
    />
    <SimplingDetails
      v-show="activeStep === 3"
      @nextStep="$emit('nextStep', $event)"
      @prevStep="$emit('prevStep', $event)"
    />
    <Review
      v-if="activeStep === 4"
      @nextStep="$emit('nextStep', $event)"
      @prevStep="$emit('prevStep', $event)"
      @showTerms="$emit('showTerms')"
    />
    <Instructions
      v-if="activeStep === 5"
      @nextStep="$emit('nextStep', $event)"
      @prevStep="$emit('prevStep', $event)"
    />
    <ShareReport
      v-if="activeStep === 6"
      @nextStep="$emit('nextStep', $event)"
      @prevStep="$emit('prevStep', $event)"
      @showTerms="$emit('showTerms')"
      @showPrivecy="$emit('showPrivecy')"
    />
    <FinalStep
      v-if="activeStep === 7"
      @nextStep="$emit('nextStep', $event)"
      @prevStep="$emit('prevStep', $event)"
      @showTerms="$emit('showTerms')"
      @showPrivecy="$emit('showPrivecy')"
    />
  </div>
</template>

<script>
// These are YOUR v2 specific components in kit-two/components/
import CreateProfile from "./KitActivation/CreateProfile";
import Notification from "./KitActivation/Notification";
import SimplingDetails from "./KitActivation/SimplingDetails";
import Review from "./KitActivation/Review";
import Instructions from "./KitActivation/Instructions";
import ShareReport from "./KitActivation/ShareReport";
import FinalStep from "./KitActivation/FinalStep";

export default {
  name: "KitV2",
  props: ["activeStep"],
  data() {
    return { notificationData: null };
  },
  components: {
    CreateProfile, Notification, SimplingDetails,
    Review, Instructions, ShareReport, FinalStep
  },
  methods: {
    handlePrevStep(e) {
      if (e.notificationData) {
        this.notificationData = e.notificationData;
        this.$emit("prevStep", e.step);
      } else {
        this.$emit("prevStep", e);
      }
    }
  }
};
</script>